import { render, staticRenderFns } from "./OrderPositions.vue?vue&type=template&id=2ddc9e09&scoped=true&"
import script from "./OrderPositions.vue?vue&type=script&lang=js&"
export * from "./OrderPositions.vue?vue&type=script&lang=js&"
import style0 from "./OrderPositions.vue?vue&type=style&index=0&id=2ddc9e09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc9e09",
  null
  
)

export default component.exports